import { useGetJwtLoginIdp } from '@framework/api-client';
import qs from 'qs';
import { useDispatch } from 'react-redux';
import { AuthSource } from '../../AuthSource';
import { AuthActions } from '../../state/AuthSlice';

/**
 * Effettua il login automatico con l'IDP presente nell'URL.
 * Viene utilizzato in seguito alla Redirezione automatica dell'IDP da parte
 * della componente di backend `GET /jwt/login/:idp`.
 */
export function useIdpAutoLogin(source: AuthSource) {
  const dispatch = useDispatch();

  // Estrae il parametro `idp` dall'URL
  const queryString = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const idp =
    queryString?.idp && typeof queryString.idp === 'string'
      ? queryString.idp
      : null;

  const loginResult = useGetJwtLoginIdp(idp!, {
    query: {
      enabled: idp != null,
      // Callback di successo
      onSuccess: (result: any) => {
        dispatch(
          AuthActions.loginSucceed({
            strategy: 'jwt',
            accessToken: result.accessToken,
            refreshToken: result.refreshToken,
            logoutUrls: result.logoutUrls ?? [],
          }),
        );
      },
    },
    request: {
      headers: {
        'X-Login-Provenienza': source,
        'X-Requested-With': 'XMLHttpRequest',
      },
    },
  });

  return loginResult;
}
